<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='会员列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-input v-model="param.keyword" placeholder="请输入邮箱" style="width: 300px;" clearable @clear="search" @keyup.enter.native="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column prop="email" label="邮箱" align="center" ></el-table-column>
        <el-table-column prop="nick_name" label="昵称" align="center"></el-table-column>
        <el-table-column label="身份" align="center">
          <template slot-scope="scope">
            {{scope.row.worker_id | getTitleById(workerList)}}
          </template>
        </el-table-column>
        <el-table-column label="订阅状态" align="center">
          <template slot-scope="scope">
            {{scope.row.is_sub === 1 ? '已订阅' : '未订阅'}}
          </template>
        </el-table-column>
        <el-table-column label="注册时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showInfoDialog(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       :current-page="param.page"
       :page-sizes="[10, 20, 30, 40, 50]"
       :page-size="param.count"
       layout="total, sizes, prev, pager, next, jumper"
       :total="total">
     </el-pagination>
     <user-info
       :visible="infoDialogAvaible"
       :id="currentId"
       :workerList="workerList"
       :ageList="ageList"
       :areaList="areaList"
       :interestList="interestList"
       @closeDialog="closeInfoDialog">
     </user-info>
    </el-card>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import UserInfo from './UserInfo.vue'
export default {
  name: 'user_list',
  components: {
    'bread-crumb': BreadCrumb,
    'user-info': UserInfo
  },
  created () {
    this.getWorkerList()
    this.getAgeList()
    this.getAreaList()
    this.getInterestList()
    this.getList()
  },
  data () {
    return {
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        page: 1,
        count: 10,
        keyword: ''
      },
      workerList: [],
      ageList: [],
      areaList: [],
      interestList: [],
      currentId: 0,
      infoDialogAvaible: false
    }
  },
  filters: {
    getTitleById (id, valueList) {
      for (var i = 0; i < valueList.length; i++) {
        if (id === valueList[i].id) {
          return valueList[i].title
        }
      }
      return ''
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/user/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getWorkerList () {
      const res = await this.$http.get('/admin/user_config/select_list', { type: 10 })
      if (res.code === 0) {
        this.workerList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAgeList () {
      const res = await this.$http.get('/admin/user_config/select_list', { type: 20 })
      if (res.code === 0) {
        this.ageList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAreaList () {
      const res = await this.$http.get('/admin/user_config/select_list', { type: 30 })
      if (res.code === 0) {
        this.areaList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getInterestList () {
      const res = await this.$http.get('/admin/user_config/select_list', { type: 40 })
      if (res.code === 0) {
        this.interestList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showInfoDialog (id) {
      this.infoDialogAvaible = true
      this.currentId = id
    },
    closeInfoDialog (id) {
      this.infoDialogAvaible = false
      this.currentId = 0
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
}
</style>
